<template>
  <div class="kanban-board">
    <div
      class="kanban-column"
      v-for="column in columns"
      :key="column.id"
      :data-column-id="column.id"
    >    
      <h3>{{ column.name }} <el-tag type="info">{{ column.tasks.length }} tarefa(s)</el-tag></h3>    
      <draggable
        :list="column.tasks"
        @change="onDragEnd"
        item-key="id"
        class="kanban-column-body"
        group="tasks"
      >
        <template #item="{ element }">
          <div class="task-card" @click="goToTask(element.id, element.slug)">
            <div 
              class="task-card-header"
              :class="{ 'task-overdue': element.deadline.overdue }">
              <span>
                #{{ element.id }} - {{ element.title }}
              </span>
            </div>
            <div class="task-card-body">
              <div class="task-info-card">
                <el-tag v-if="element.client_name" type="warning">
                  {{ element.client_name }}                  
                </el-tag>                                  
                <p style="margin: 5px 0">
                  Realizar até {{ element.expected_date }}
                </p>
              </div>          
              <div class="task-tags">
                <span
                  v-for="(category, idx) in element.categories"
                  :key="idx"
                  class="task-tag"
                >
                  {{ category.name }}
                </span>
              </div>
              <div class="task-footer">
                <el-row :gutter="20">
                  <el-col :span="16">
                    <span class="task-user">
                      <el-icon :size="12"><User /></el-icon>
                      {{ element.responsible_name }}

                      <el-icon v-if="element.isWork" class="task-isWork blink">
                        <Clock />
                      </el-icon>
                    </span>                    
                  </el-col>
                  <el-col class="column-priority" :span="8">
                    <task-priority :type="element.priority" />                  
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </template>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import TaskPriority from "./TaskPriority.vue";

export default {
  props: {
    tasks: Object,
  },
  components: {
    draggable,
    TaskPriority
  },
  data() {
    return {
      urlApi: process.env.VUE_APP_API_URL,
      columns: [
        { id: 0, name: "A Fazer", tasks: [] },
        { id: 1, name: "Fazendo", tasks: [] },
        { id: 2, name: "Pendente", tasks: [] },
        { id: 3, name: "Validando", tasks: [] },
        { id: 4, name: "Concluída", tasks: [] },
        { id: 5, name: "Arquivada", tasks: [] },
      ],
    };
  },
  methods: {
    sortTasksIntoColumns() {
      console.log('------------------ organizando tasks')
      this.columns.forEach((column) => {
        column.tasks = this.tasks.filter((task) => task.stage === column.id);
      });

      console.warn(':::: COLUNAS ORGANIZADAS :::: ', this.columns)
    },
    async onDragEnd(event) {
      console.warn('event >>> ', event)

      if (event.added) {
        console.log('event added >>> ', event.added)
      }

      if (event.removed) {
        console.log('event removed >>> ', event.removed)
      }
    },
    goToTask(id, slug) {
      this.$router.push({
        name: 'TaskDetails',
        params: {
          id: id,
          slug: slug
        }
      })
    }
  },
  mounted() {
    if (this.tasks && this.tasks.length > 0) {
      this.sortTasksIntoColumns();
    }
  },
  watch: {
    tasks: {
      handler(newTasks) {
        if (newTasks && newTasks.length > 0) {
          this.sortTasksIntoColumns();
        }
      },
      immediate: true, // Executa o watch assim que o componente é montado
    },
  }
};
</script>
  
<style scoped>
  /* Container principal do board */
  .kanban-board {
    display: flex;
    overflow-x: auto; /* Permite rolar horizontalmente quando necessário */
    gap: 16px;
    padding: 16px;
  }

  /* Coluna do Kanban */
  .kanban-column {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-width: 250px;
    max-width: 300px;
    background-color: #f4f5f7;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    flex-grow: 1;
    transition: all 0.3s ease-in-out;
    overflow-x: hidden;
  }

  /* Título da coluna */
  .kanban-column h3 {
    font-size: 1.2rem;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-bottom: 15px;
  }

  /* Estilo do corpo da coluna */
  .kanban-column-body {
    flex-grow: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* Cartão de Tarefa */
  .task-card {
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    padding: 0;
    transition: transform 0.2s ease-in-out;
    cursor: pointer;    
  }

  /* Quando o cartão é arrastado, adiciona um efeito */
  .task-card:active {
    transform: scale(1.05);
  }

  /* Cabeçalho do cartão */
  .task-card-header {
    font-size: 0.8rem;
    font-weight: bold;
    color: #666;
    margin-bottom: 8px;    
    background: #feffd3;
    border-radius: 6px 6px 0 0;
    padding: 7px;
  }

  /* Corpo do cartão */
  .task-card-body {
    font-size: 0.6rem;
    color: #7f8c8d;
    padding: 7px;
  }

  /* Tags da tarefa */
  .task-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 8px;
  }

  /* Estilo das tags */
  .task-tag {
    background-color: #e0e0e0;
    border-radius: 3px;
    padding: 4px 8px;
    font-size: 0.6rem;
    font-weight: bold;
    color: #34495e;
  }

  /* Rodapé do cartão */
  .task-footer {
    font-size: 0.85rem;
    color: #95a5a6;
    margin-top: 12px;
  }

  .task-user {
    background: #edfbff;
    padding: 5px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 0.6rem;
    display: flex;
    color: #666;
  }

  .task-user i {
    margin-right: 2px;
  }

  .column-priority {
    text-align: end;
  }

  /* Responsividade */
  @media (max-width: 1200px) {
    .kanban-board {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  @media (max-width: 768px) {
    .kanban-column {
      min-width: 200px;
      max-width: 250px;
    }
  }

  @media (max-width: 480px) {
    .kanban-column {
      min-width: 180px;
      max-width: 220px;
    }

    .task-card {
      font-size: 0.85rem;
    }
  }

  .item-badge {
    margin: 10px 30px 0 0;
  }

  .task-overdue {
    background: #f00;
    color: #fff;
  }

  .task-isWork {
    margin: 0 5px;
    color: #333;
    font-size: 12px;
    font-weight: bold;
  }

  @keyframes blink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
  
  /* Aplica a animação à classe blink */
  .blink {
    animation: blink 1s infinite;
  }
</style>
  